import { Loader2, Plus, X } from 'lucide-react';
import React, { useState } from 'react';
import blogAPI from '../../services/blogAPI';
import './BlogCategoryModal.css';

const BlogCategoryModal = ({ isOpen, onClose, onSuccess }) => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        slug: '',
        color: '#3b82f6'
    });
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name.trim()) {
            setError('Category name is required');
            return;
        }

        setSaving(true);
        setError('');

        try {
            await blogAPI.createCategory(formData);
            alert('Blog category created successfully!');
            onSuccess();
            onClose();
        } catch (err) {
            console.error('Error creating category:', err);
            setError(err.response?.data?.message || 'Failed to create category');
        } finally {
            setSaving(false);
        }
    };

    const handleNameChange = (e) => {
        const name = e.target.value;
        const slug = name
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)/g, '');

        setFormData({
            ...formData,
            name,
            slug
        });
    };

    if (!isOpen) return null;

    return (
        <div className="blog-category-modal-overlay" onClick={onClose}>
            <div className="blog-category-modal" onClick={(e) => e.stopPropagation()}>
                <div className="blog-category-modal-header">
                    <h2>Create Blog Category</h2>
                    <button className="close-btn" onClick={onClose}>
                        <X size={24} />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="blog-category-form">
                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}

                    <div className="form-group">
                        <label htmlFor="name">Category Name *</label>
                        <input
                            id="name"
                            type="text"
                            value={formData.name}
                            onChange={handleNameChange}
                            placeholder="e.g., Traffic Laws, Driving Tips"
                            className="form-input"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="slug">Slug</label>
                        <input
                            id="slug"
                            type="text"
                            value={formData.slug}
                            onChange={(e) => setFormData({ ...formData, slug: e.target.value })}
                            placeholder="auto-generated-from-name"
                            className="form-input"
                        />
                        <small className="form-help">Auto-generated from name. You can customize it.</small>
                    </div>

                    <div className="form-group">
                        <label htmlFor="description">Description</label>
                        <textarea
                            id="description"
                            value={formData.description}
                            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                            placeholder="Brief description of this category"
                            className="form-textarea"
                            rows="3"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="color">Color</label>
                        <div className="color-input-group">
                            <input
                                id="color"
                                type="color"
                                value={formData.color}
                                onChange={(e) => setFormData({ ...formData, color: e.target.value })}
                                className="form-color-input"
                            />
                            <input
                                type="text"
                                value={formData.color}
                                onChange={(e) => setFormData({ ...formData, color: e.target.value })}
                                className="form-input"
                                placeholder="#3b82f6"
                            />
                        </div>
                        <small className="form-help">Used to identify the category visually</small>
                    </div>

                    <div className="form-actions">
                        <button
                            type="button"
                            onClick={onClose}
                            className="btn-secondary"
                            disabled={saving}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn-primary"
                            disabled={saving}
                        >
                            {saving ? (
                                <>
                                    <Loader2 size={18} className="animate-spin" />
                                    Creating...
                                </>
                            ) : (
                                <>
                                    <Plus size={18} />
                                    Create Category
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default BlogCategoryModal;


